import { Alert, Button } from '@factorialco/deprecated-design-system'
import { DisableMfaAccessDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  accessId: string
  onClose: () => void
}

const DisableMfaModal = ({ accessId, onClose }: Props) => {
  const [disableMfa, { loading: _loading }] = useMutation(DisableMfaAccessDocument, {
    extractorFn: (data) => data.authenticationMutations.disableMfaAuthenticationAccess,
  })

  const onSubmit = async () => {
    const data = await disableMfa({ variables: { id: accessId } })
    const result = handleResult(data, () => undefined)

    if (result?.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('employees.disable_mfa.success'),
        time: 2000,
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('employees.disable_mfa.error'),
        time: 2000,
      })
    }

    onClose()
  }

  return (
    <Modal
      title={i18n.t('employees.disable_mfa.title')}
      description={i18n.t('employees.disable_mfa.description')}
      illustration="lock-user"
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={onSubmit} submit>
            {i18n.t('employees.disable_mfa.submit')}
          </Button>
        </>
      }
    >
      <Alert color="warning">{i18n.t('employees.disable_mfa.alert')}</Alert>
    </Modal>
  )
}

export default DisableMfaModal
